import { Response } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'

export interface SignupResponse extends Response {
	data: {
		inserted_item: SignupResult
	}
}

export type SignupResult = {
	no: string
	username: string
	status: string
	role_no: string
	role: RoleType
	create_date: string
	modify_date: string
	delete_data: string | null
}

type RoleType = {
	no: string
	role: string
}

export type SignupPayload = {
	username: string
	password: string
}

export const signup = async ({ username, password }: SignupPayload): Promise<SignupResponse> => {
	const response = await client.post<SignupResponse>(`auth/signup`, {
		username,
		password,
	})

	return response.data
}
